import ComponentModule from 'lib/component-module';
import tabs from 'lib/tabs';
import {
    tabSelectMobile as tabSelectMobileTemplate,
    productItem as productItemTemplate,
    documentItem as documentItemTemplate,
    softwareItem as softwareItemTemplate,
    articleItem as articleItemTemplate
} from 'lib/template-strings/my-saved-page';
import store from "../store";
// import axios from "axios"
// import fpodb from '../../../../db.json';
import EventBus from '../event-bus';
import VModal from 'vue-js-modal';
import {releaseNotesModal} from './../modals';
import Vue from 'vue/dist/vue.min.js';

Vue.use(VModal);

ComponentModule.AddModule('.my-saved-page', {
    prefix: 'my-saved-page-',
    components: [
        tabs({
            data: function() {
                return {
                    savedIds: {
                        products: [],
                        documents: [],
                        software: [],
                        articles: [],
                        legalDocuments: []
                    }
                }
            },
            computed: {
                savedProducts: function() {
                    return store.state.favorites.productId;
                },
                savedDocuments: function() {
                    return store.state.favorites.documentId;
                },
                savedSoftware: function() {
                    return store.state.favorites.softwareId;
                },
                savedArticles: function() {
                    return store.state.favorites.articleId;
                },
                savedLegalDocuments: function() {
                    return store.state.favorites.legalDocumentId;
                },
            },
            watch: {
                savedProducts: function() {
                    this.savedIds.products = this.savedProducts[0] == "" ? this.savedProducts.shift() : this.savedProducts;
                },
                savedDocuments: function() {
                    this.savedIds.documents = this.savedDocuments[0] == "" ? this.savedDocuments.shift() : this.savedDocuments;
                },
                savedSoftware: function() {
                    this.savedIds.software = this.savedSoftware[0] == "" ? this.savedSoftware.shift() : this.savedSoftware;
                },
                savedArticles: function() {
                    this.savedIds.articles = this.savedArticles[0] == "" ? this.savedArticles.shift() : this.savedArticles;
                },
                savedLegalDocuments: function() {
                    this.savedIds.legalDocuments = this.savedLegalDocuments[0] == "" ? this.savedLegalDocuments.shift() : this.savedLegalDocuments;
                }
            },
            methods: {
                initSavedIds() {
                    this.savedIds.products = this.savedProducts[0] == "" ? this.savedProducts.shift() : this.savedProducts;
                    this.savedIds.documents = this.savedDocuments[0] == "" ? this.savedDocuments.shift() : this.savedDocuments;
                    this.savedIds.software = this.savedSoftware[0] == "" ? this.savedSoftware.shift() : this.savedSoftware;
                    this.savedIds.articles = this.savedArticles[0] == "" ? this.savedArticles.shift() : this.savedArticles;
                    this.savedIds.legalDocuments = this.savedLegalDocuments[0] == "" ? this.savedLegalDocuments.shift() : this.savedLegalDocuments;
                }
            },
            created() {
                this.initSavedIds();
            },
            mounted() {
            },
            components: {
                tabSelectMobile: {
                    name: 'tab-select-mobile',
                    template: tabSelectMobileTemplate,
                    props: {
                        currentTab: [String, Number],
                        selectClass: { type: String, default: 'my-saved-page__tab-select' },
                        changeTab: Function,
                        savedData: Object
                    },
                    data: function() {
                        const data = {
                            options: [],
                        };

                        return data;
                    },
                    mounted() {
                        const defaultSlots = this.$slots.default;
                        const childSlot = defaultSlots && defaultSlots[0]
                        const children = childSlot && childSlot.children;
                        if (children) {
                            
                            children.forEach(c => {
                                const options = c.componentOptions;
                                if (!options || options.tag !== 'tab'){
                                    return;
                                }

                                const props = options.propsData;
                                const span = options.children[0];
                                const text = span && span.children[0] && span.children[0].text;
                                const id = props.idTab;

                                this.options.push({id, text});
                            });
                        }
                    },
                    methods: {
                        change: function(e) {
                            this.changeTab(e.target.value);
                        }
                    }
                },
                savedProducts: {
                    name: 'saved-products',
                    props: ['savedIds'],
                    data: function() {
                        return {
                            checked: [],
                            checkedStr: null
                        }
                    },
                    watch: {
                        "checked": function() {
                            this.checkedStr = this.checked.map((item) => {
                                return `${item.name}`
                            }).join(`\n`);
                        }
                    },
                    components: {
                        productItem: {
                            name: 'product-item',
                            // template: productItemTemplate,
                            props: ['checked', 'savedIds'],
                            data: function() {
                                const data = {
                                    id: null,
                                    isChecked: null,
                                    isBookmarked: false,
                                    type: 'productId'
                                };
        
                                return data;
                            },
                            watch: {
                                isChecked: function() {
                                    let param = this.isChecked ? "add" : "remove";
                                    let url = this.$refs.url.getAttribute('href');
                                    let name = this.$refs.url.innerText;

                                    let obj = {
                                        'id': this.id,
                                        'url': url,
                                        'name': name
                                    }

                                    EventBus.$emit('update-checked', param, obj);
                                },
                                "savedIds.products": function() {
                                    this.isBookmarked = this.savedIds.products.includes(this.id) ? true : false;
                                }
                            },
                            mounted() {
                                this.id = this.$refs.checkbox.dataset.productId;
                                this.isBookmarked = this.savedIds.products.includes(`${this.id}`) ? true : false;
                            },
                            methods: {
                                handleBookmark() {
                                    store.commit('updateFavorites', {
                                        id: this.id,
                                        type: this.type,
                                        action: this.isBookmarked ? "remove" : "add"
                                    });
                                    store.dispatch('checkFavorites');
                                }
                            },
                        },
                    },
                    methods: {
                        requestaquote() {
                            console.log("REQUEST A QUOTE");
                        }
                    },
                    mounted() {
                        EventBus.$on('update-checked', (param, value) => {
                            if ( param == "add") {
                                this.checked.push(value);
                            } else {
                                let match = this.checked.find((item) => {
                                    return item.id == value.id
                                });

                                let index = this.checked.map((item) => {
                                    return item.id;
                                }).indexOf(value.id);
                                if (match) {
                                    this.checked.splice(this.checked.indexOf(index), 1);
                                }

                            }
                        });
                    }
                },  
                docItem: {
                    name: 'doc-item',
                    props: ['savedIds'],
                    data: function() {
                        return {
                            id: null,
                            isBookmarked: false,
                            type: 'documentId',
                            seeAll: null, //is "see all" feature enabled,
                            seeAllOpen: null,
                            seeAllLabel: null,//label
                            moreContent: null,
                        }
                    },
                    components: {

                    },
                    watch: {
                        "savedIds.documents": function() {
                            this.isBookmarked = this.savedIds.documents.includes(this.id) ? true : false;
                        },
                        "seeAll": function() {
                            if (this.seeAll) {
                                this.seeAllLabel = this.seeAllOpen ? window.seeLessLabel : window.seeAllLabel;
                            }
                        }
                    },
                    methods: {
                        toggleSeeAll() {
                            this.seeAllOpen = !this.seeAllOpen;
                        },
                        handleBookmark() {
                            store.commit('updateFavorites', {
                                id: this.id,
                                type: this.type,
                                action: this.isBookmarked ? "remove" : "add"
                            });
                            store.dispatch('checkFavorites');
                        },
                        initSeeAll() {
                            if (this.$refs.seeAllContent) {
                                let details = this.$refs.seeAllContent.innerHTML.split(',');
                                this.seeAll = details.length > 3 ? true : false;

                                let truncatedDetails = details.slice(0,3).join();
                                let moreDetails = details.slice(3).join();

                                this.moreContent = moreDetails;
                                this.$refs.seeAllContent.innerHTML = `${truncatedDetails}${moreDetails == "" ? '' : ','}`;
                            }
                        }
                    },
                    mounted() {
                        this.id = this.$refs.bookmark.dataset.documentId;
                        this.isBookmarked = this.savedIds.documents.includes(`${this.id}`) ? true : false;
                        this.initSeeAll();
                    }
                },
                legalDocItem: {
                    name: 'legal-doc-item',
                    props: ['savedIds'],
                    data: function() {
                        return {
                            id: null,
                            isBookmarked: false,
                            type: 'legalDocumentId',
                            seeAll: null, //is "see all" feature enabled,
                            seeAllOpen: null,
                            seeAllLabel: null,//label
                            moreContent: null,
                        }
                    },
                    components: {

                    },
                    watch: {
                        "savedIds.legalDocuments": function() {
                            this.isBookmarked = this.savedIds.legalDocuments.includes(this.id) ? true : false;
                        },
                        "seeAll": function() {
                            if (this.seeAll) {
                                this.seeAllLabel = this.seeAllOpen ? window.seeLessLabel : window.seeAllLabel;
                            }
                        }
                    },
                    methods: {
                        toggleSeeAll() {
                            this.seeAllOpen = !this.seeAllOpen;
                        },
                        handleBookmark() {
                            store.commit('updateFavorites', {
                                id: this.id,
                                type: this.type,
                                action: this.isBookmarked ? "remove" : "add"
                            });
                            store.dispatch('checkFavorites');
                        },
                        initSeeAll() {
                            if (this.$refs.seeAllContent) {
                                let details = this.$refs.seeAllContent.innerHTML.split(',');
                                this.seeAll = details.length > 3 ? true : false;

                                let truncatedDetails = details.slice(0,3).join();
                                let moreDetails = details.slice(3).join();

                                this.moreContent = moreDetails;
                                this.$refs.seeAllContent.innerHTML = `${truncatedDetails},`;
                            }
                        }
                    },
                    mounted() {
                        this.id = this.$refs.bookmark.dataset.legalDocumentId;
                        this.isBookmarked = this.savedIds.legalDocuments.includes(`${this.id}`) ? true : false;
                        this.initSeeAll();
                    }
                },
                softwareItem: {
                    name: 'software-item',
                    props: ['savedIds'],
                    data: function() {
                        return {
                            id: null,
                            isBookmarked: false,
                            type: 'softwareId',
                        }
                    },
                    components: {

                    },
                    watch: {
                        "savedIds.software": function() {
                            this.isBookmarked = this.savedIds.software.includes(this.id) ? true : false;
                        }
                    },
                    methods: {
                        handleBookmark() {
                            store.commit('updateFavorites', {
                                id: this.id,
                                type: this.type,
                                action: this.isBookmarked ? "remove" : "add"
                            });
                            store.dispatch('checkFavorites');
                        },
                        toggleModal() {
                            let releaseNotes = this.$refs.releaseNotes.innerHTML;
                            this.$modal.show(
                                releaseNotesModal.template(releaseNotes),
                                releaseNotesModal.name,
                                releaseNotesModal.options
                            )
                        }
                    },
                    mounted() {
                        this.id = this.$refs.bookmark.dataset.softwareId;
                        this.isBookmarked = this.savedIds.software.includes(`${this.id}`) ? true : false;
                    }
                },
                articleItem: {
                    name: 'article-item',
                    props: ['savedIds'],
                    data: function() {
                        return {
                            id: null,
                            isBookmarked: false,
                            type: 'articleId',
                        }
                    },
                    components: {

                    },
                    watch: {
                        "savedIds.articles": function() {
                            this.isBookmarked = this.savedIds.articles.includes(this.id) ? true : false;
                        }
                    },
                    methods: {
                        handleBookmark() {
                            store.commit('updateFavorites', {
                                id: this.id,
                                type: this.type,
                                action: this.isBookmarked ? "remove" : "add"
                            });
                            store.dispatch('checkFavorites');
                        }
                    },
                    mounted() {
                        this.id = this.$refs.bookmark.dataset.articleId;
                        this.isBookmarked = this.savedIds.articles.includes(`${this.id}`) ? true : false;
                    }
                }
                
            },
            tabProps: {
                savedIds: Object
            },
            tabOptions: {
                computed: {
                    taggingMeta: function() {
                        return null
                    }
                }
            }, 
            tabContentOptions: {
                computed: {
                    taggingMeta: function() {
                        return null
                    }
                }
            },  
            contentProps: {
                savedIds: Object
            }
        }),
        
    ]
});

// window.seeLessLabel = "see less";
// window.seeAllLabel = "see more";